import BaseApi from '../baseApi';

export default class WhatsAppChatApi extends BaseApi {
  constructor(obj) {
    obj = obj || {};
    super(obj);
  }

  /**
   * Lista conversas do WhatsApp via Z-API.
   * @returns {Promise<{ data: Array<{ phone: string, name: string, imgUrl: string, unreadMessages: number }> }>}
   */
  getConversations() {
    return this.api
      .get('/whatsapp/chat/conversations')
      .catch(() => ({ data: { error: true } }));
  }

  /**
   * Busca mensagens de uma conversa com paginacao.
   * @param {string} phone - Numero do contato (apenas digitos)
   * @param {number} [page=1] - Pagina atual
   * @param {number} [limit=50] - Mensagens por pagina
   * @returns {Promise<{ data: { messages: Array, hasMore: boolean, total: number } }>}
   */
  getMessages(phone, page = 1, limit = 50) {
    return this.api
      .get('/whatsapp/chat/messages', { params: { phone, page, limit } })
      .catch(() => ({ data: { error: true } }));
  }

  /**
   * Envia mensagem de texto via WhatsApp Chat.
   * @param {string} phone - Numero do contato (apenas digitos)
   * @param {string} message - Texto da mensagem
   * @returns {Promise<{ data: object }>}
   */
  sendMessage(phone, message) {
    return this.api
      .post('/whatsapp/chat/send-message', { phone, message })
      .catch(() => ({ data: { error: true } }));
  }

  /**
   * Envia arquivo (imagem ou documento) via WhatsApp Chat.
   * @param {string} phone - Numero do contato (apenas digitos)
   * @param {File} file - Arquivo selecionado pelo usuario
   * @param {string} [caption] - Legenda opcional
   * @returns {Promise<{ data: object }>}
   */
  sendFile(phone, file, caption) {
    const formData = new FormData();

    formData.append('phone', phone);
    formData.append('file', file);

    if (caption) {
      formData.append('caption', caption);
    }

    return this.api
      .post('/whatsapp/chat/send-file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 60000
      })
      .catch(() => ({ data: { error: true } }));
  }

  /**
   * Envia botao PIX via WhatsApp (chave PIX com botao de copiar).
   * @param {string} phone - Numero do contato (com DDI, apenas digitos)
   * @param {string} pixKey - Chave PIX (copia-e-cola)
   * @param {string} [pixKeyType='EVP'] - Tipo da chave: CPF, CNPJ, PHONE, EMAIL ou EVP
   * @param {string} [title] - Titulo do botao
   * @returns {Promise<{ data: object }>}
   */
  sendPix(phone, pixKey, pixKeyType, title) {
    return this.api
      .post('/whatsapp/chat/send-pix', { phone, pixKey, pixKeyType, title })
      .catch(() => ({ data: { error: true } }));
  }

  /**
   * Marca todas as mensagens recebidas de um phone como lidas.
   * @param {string} phone - Numero do contato (apenas digitos)
   * @returns {Promise<{ data: { markedCount: number } }>}
   */
  markConversationAsRead(phone) {
    return this.api
      .put('/whatsapp/chat/mark-read', { phone })
      .catch(() => ({ data: { markedCount: 0 } }));
  }

  /**
   * Retorna contagem total de mensagens recebidas nao lidas.
   * @returns {Promise<{ data: { unreadCount: number } }>}
   */
  getUnreadCount() {
    return this.api
      .get('/whatsapp/chat/unread-count')
      .catch(() => ({ data: { unreadCount: 0 } }));
  }
}
